<template>
	<div id='Map'></div>
	<div id='district_info_short' class='hidden'>
		<h4 id='district_info_name'>Nome</h4>
		<p id='district_info_tot_pop'>Pop. totale: <span>x</span></p>
		<p id='district_info_perc_str'>Pop. non italiana: <span>x</span></p>
		<p id='district_info_tot_walk'>Sup. calpestabile: <span>x</span></p>
		<p id='district_info_perc_green'>Copertura vegetale: <span>x</span></p>
	</div>
	<div id='distr_label' class='hidden'>distr</div>
</template>
<script>
export default {
	name : 'Map', 
	mounted() {
		this.draw(this)
	},
	data() {
		return {
			dists_to_show : [], 
			modality : 'add'
		}
	},
	emits: ['showDists'],
	methods : {
		update_distrs(dist) {
			if (this.dists_to_show.indexOf(dist) > -1) {
				let idx = this.dists_to_show.indexOf(dist)
				this.dists_to_show.splice(idx, 1)
			} else {
				this.dists_to_show.push(dist)
			}

			this.$emit('showDists', this.dists_to_show)
		},
		draw() {
			let component = this;

			mapboxgl.accessToken = 'pk.eyJ1IjoibWFydGFmaW9yYXZhbnRpIiwiYSI6ImNrb2szcHYwdjBmamYydnFmZDcycmg4bmIifQ.9CX8vA17v8m0JOvlsYWd-A';
			let map = new mapboxgl.Map({
				container : 'Map',
				style : 'mapbox://styles/martafioravanti/cknnfxoyn4dr717mgtihd9551', // stylesheet location
				center : [11.79, 45.07], // starting position [lng, lat]
				maxBounds : [	[11.4, 44.8],
								[12.2, 45.20],
							], 
				zoom : 10, // starting zoom
				minZoom : 8,
				maxZoom : 19,
			}) 

			let districts = require('/src/assets/districts.json')
			let veg_areas = require('/src/assets/vegetated_areas.json')
			//let veg_green_areas = require('/src/assets/green_df.json')
			let veg_blue_areas = require('/src/assets/blue_df.json')

			map.on('load', function () {
				
				map.addSource('veg_areas', {
					'type': 'geojson',
					'data' : veg_areas,
				})

				map.addSource('veg_blue_areas', {
					'type': 'geojson',
					'data' : veg_blue_areas,
				})


				let layers = map.getStyle().layers
				// Find the index of the first symbol layer in the map style
				let first_fill_ID;
				for (var i = 0; i < layers.length; i++) {
					if (layers[i].type === 'fill') {
						first_fill_ID = layers[i].id
						break;
					}
				}

				map.addSource('districts', {
					'type': 'geojson',
					'data' : districts,
				})

				map.addSource('districts_1', {
					'type': 'geojson',
					'data' : districts,
				})

				const dist_poly = map.addLayer({
					'id': 'districts_fill',
					'type': 'fill',
					'source': 'districts_1',
					'paint': {
						'fill-color': '#000',
						'fill-opacity': [
							'case',
							['boolean',  ['feature-state', 'click'], true],
							[
								'case',
								['boolean',  ['feature-state', 'hover'], false],
								0.5,
								0.01
							],
							1,
						],
						/*'fill-opacity': [
							'case',
							['boolean',  ['feature-state', 'click'], true],
							0.5,
							1,
						],*/
					},
					'filter': ['==', '$type', 'Polygon'],
				}, first_fill_ID)

				layers = map.getStyle().layers
				// Find the index of the first symbol layer in the map style
				let second_fill_ID;
				for (var i = 0; i < layers.length; i++) {
					if (layers[i].type === 'fill' && layers[i].type != 'districts_fill') {
						first_fill_ID = layers[i].id
						break;
					}
				}

				const veg_poly = map.addLayer({
					'id': 'veg_areas',
					'type': 'fill',
					'source': 'veg_areas',
					'paint': {
						'fill-color': '#90EE90',
						'fill-opacity': .35,
					},
				}, second_fill_ID)

				const blue_poly = map.addLayer({
					'id': 'veg_blue_areas',
					'type': 'fill',
					'source': 'veg_blue_areas',
					'paint': {
						'fill-color': '#0D256E',
						'fill-opacity': .35,
					},
				})


				map.addLayer({
					'id': 'districts',
					'type': 'line',
					'source': 'districts',
					'paint': {
						'line-color': '#87CEFA',
						'line-opacity': 0.2,
						'line-width' : 1.2,
						//'line-dasharray' : [2, 4]
					},
					'filter': ['==', '$type', 'Polygon'],
				})

				let infos = $('#district_info_short'), 
					dist_lab = $('#district_info_name'),
					dist_pop = $('#district_info_tot_pop'),
					dist_str = $('#district_info_perc_str'),
					dist_veg = $('#district_info_perc_green'),
					dist_walk = $('#district_info_tot_walk')

				let data = require('/src/assets/final_df.json')
				let d_label = $('#distr_label')

				let hoveredStateId = null;

				map.on('mousemove', 'districts_fill', function (e) {
					if (e.features.length > 0) {
						if (hoveredStateId !== null) {	
							map.setFeatureState(
								{ source: 'districts_1', id: hoveredStateId },
								{ hover: false }
							);
						}
						
						hoveredStateId = e.features[0].id;
						
						map.setFeatureState(
							{ source: 'districts_1', id: hoveredStateId },
							{ hover: true }
						);

						infos.removeClass('hidden')
						hoveredStateId = e.features[0].id

						let readable_name = e.features[0].properties['Quartiere'].replace("e'", 'è').replace('SANTAPOLLINARE', "SANT'APOLLINARE").toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())

						dist_lab.html(readable_name)
						let dist = e.features[0].properties['Quartiere'].toLowerCase().replaceAll(' ', '_').replace("e'", 'è')

						let dist_data = data[dist]

						dist_pop.find('span').html(dist_data.tot_pop)
						dist_str.find('span').html(dist_data.stran_perc + '%')
						dist_veg.find('span').html(dist_data.veg_perc + '% della superficie calpestabile')
						dist_walk.find('span').html(dist_data.walkable_km2 + ' km^2')

						let x = e.point.x,
        					y = e.point.y

						d_label.removeClass('hidden')
						d_label.html(readable_name)
						d_label.css({top: y+24, left: x-(d_label.width()/2)})
						
					}
				})

				map.on('mouseleave', 'districts_fill', function () {
					if (hoveredStateId !== null) {
						map.setFeatureState(
							{ source: 'districts_1', id: hoveredStateId },
							{ hover: false }
						);
						infos.addClass('hidden')
						d_label.addClass('hidden')
					}
					hoveredStateId = null;
				})
				 

				map.on('click', 'districts_fill', function (e) {
					let dist = e.features[0].properties['Quartiere'].toLowerCase().replaceAll(' ', '_').replace("e'", 'è')
					if (e.features.length > 0) {
						component.update_distrs(dist)
					}

					let id = e.features[0].id 

					let clicked = map.getFeatureState(
										{ source: 'districts_1', id: id}
									)['click']


					if (clicked == false) {
						map.setFeatureState(
							{ source: 'districts_1', id: id },
							{ click: true}							
						)
					} else {
						map.setFeatureState(
							{ source: 'districts_1', id: id },
							{ click: false}							
						)

					}

				})

			})

		}
	}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#Map {
		width: 100vw;
		height: calc(100vh - 24px - 19px - 1rem - 104px);
		cursor: pointer;
		z-index: 0;
		position: absolute;
		top: 104px;
	}

	#district_info_short {
		background-color: #FFF;
		padding: 16px;
		position: absolute;
		display: block;
		text-align: left;
		max-width: 300px;
		top: 104px;
		left: 0;
	}

	#district_info_short h4 {
		font-size: 16px;
		margin-bottom: 8px;
		background-color: #FFF;
	}

	#district_info_short p {
		font-size: 14px;
		font-weight: 700;
		background-color: #FFF;
	}

	#district_info_short p span {
		font-size: 14px;
		font-weight: 400;
		background-color: #FFF;
	}

	#district_info_short.hidden {
		display: none;
	}

	#distr_label {
		position: absolute;
		display: block;
		background-color: #FFF;
		padding: 8px;
		font-size: 14px;
		font-weight: bold;
	}

	#distr_label.hidden {
		display: none;
	}
</style>
